import { faEllipsisVertical, faRotateLeft, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { useDrag, useDrop } from 'react-dnd';

function WidgetFileItemEdit({ model, number, index, loading, changeHandler, removeHandler, removeCancelHandler, moveFile }) {

    /*
        model:
            ID_Board_Task 
            Widget_Number 
            ID_File 
            ID_Type 
            Name 
            Path 
            Order 
            Size
    */
    const [log, setLog] = useState(null);

    useEffect(() => {
        if (model.Size > 29360128) {
            setLog('Превышен максимальный размер файла 28мб. Файл не будет загружен');
        }
    }, [model]);

    const ref = useRef(null)
    const [{ handlerId }, drop] = useDrop({
        accept: "widget_file_" + number,
        /*drop: () => ({
            model, //Передаем в useDrag
        }),*/
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(item, monitor) {
            if (!ref.current) {
                return
            }
            const dragIndex = item.index
            const hoverIndex = index
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }
            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()
            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            // Determine mouse position
            const clientOffset = monitor.getClientOffset()
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }
            // Time to actually perform the action
            //moveBoard({ dragIndex: dragIndex, hoverIndex: hoverIndex, id_board_old: model.ID_Board, id_board_new: model_.model.ID_Board })
            moveFile({ dragIndex: dragIndex, hoverIndex: hoverIndex })
            //console.log('2', model.ID_Board)
            //console.log(monitor.getDropResult())
            //console.log(model)
            // console.log(model_.model)

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex
        },
    })
    const [{ isDragging }, drag] = useDrag({
        type: "widget_file_" + number,
        item: () => {
            return { model, index }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            //item - Изменяемая модель
            if (monitor.getDropResult() !== null) {

                //СОХРАНЕНИЕ ИЗМЕНЕНИЙ
                // moveFileSaveHandler()
            }
        }
    })
    const opacity = isDragging ? 0 : 1
    drag(drop(ref))

    const style = {
        marginTop: '.5rem',
    }

    return (
        <div ref={ref} data-handler-id={handlerId} style={{ ...style, opacity }}>

            {model.Status === 3 ?
                (
                    <div className='row_select' style={{ display: "flex" }}>
                        <strike>{model.Name}</strike>
                        <div style={{ marginLeft: "auto", }}>
                            <Button variant="outline-secondary_" onClick={() => removeCancelHandler(index)}>
                                <FontAwesomeIcon icon={faRotateLeft} />
                            </Button>
                        </div>
                    </div>
                )
                :
                (
                    <InputGroup >
                        <Button variant="light">
                            <FontAwesomeIcon icon={faEllipsisVertical} />
                        </Button>
                        <Form.Control type="text" value={model.Name} disabled={loading} onChange={(e) => changeHandler(index, e.target.value)} />
                        <Button variant="outline-danger" onClick={() => removeHandler(index)}>
                            <FontAwesomeIcon icon={faTrash} />
                        </Button>
                    </InputGroup>
                )
            }
        </div>
    )
}

export default WidgetFileItemEdit;